import { useState } from 'react';

import { DefaultOptionType } from 'antd/lib/select';

export const useLocateProductTemplate = () => {
    const [selectedWarehouses, setSelectedWarehouses] = useState<string[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);

    const onRemoveWarehouse = function (itemToRemove: string) {
        const newSelectedWarehouses = selectedWarehouses.filter(
            (value: string) => value !== itemToRemove
        );
        setSelectedWarehouses(newSelectedWarehouses);
    };

    const onApplyWarehouses = function (newSelectedWarehouses: string[]) {
        setSelectedWarehouses(newSelectedWarehouses);
    };

    const onSelectProduct = (newSelectedProduct: DefaultOptionType) => {
        if (
            newSelectedProduct.value &&
            !selectedProducts.includes(newSelectedProduct.value as string)
        ) {
            setSelectedProducts([
                ...selectedProducts,
                newSelectedProduct.value as string
            ]);
        }
    };

    const onRemoveProduct = function (itemToRemove: string) {
        const newSelectedProducts = selectedProducts.filter(
            (value: string) => value !== itemToRemove
        );
        setSelectedProducts(newSelectedProducts);
    };

    const clearFilters = function () {
        setSelectedWarehouses([]);
        setSelectedProducts([]);
    };

    return {
        selectedWarehouses,
        onRemoveWarehouse,
        onApplyWarehouses,
        selectedProducts,
        onSelectProduct,
        onRemoveProduct,
        clearFilters
    };
};
